import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { ZONE_QUERY } from 'apollo'

export const useZoneQuery = (options: QueryHookOptions<any, any> = {}) => useQuery(ZONE_QUERY, options)
